import { sanguine, ultraMarine } from '@cogneed/react-utils';
import { Box, styled } from '@mui/material';

const StyledBox = styled(Box)({
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  '& > .MuiBox-root': {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 4,
    '& > svg': {
      fontSize: 58,
      color: sanguine[400],
    },
    '& .MuiTypography-root': {
      color: sanguine[400],
      fontSize: 14,
      lineHeight: '16px',
      textAlign: 'center',
      fontWeight: 600,
    },
  },
  '& .MuiButton-root': {
    fontSize: 14,
    fontWeight: 600,
    color: ultraMarine[600],
    textTransform: 'none',
    display: 'flex',
    gap: 4,
    '&:hover': {
      textDecoration: 'underline',
    },
    '& svg': {
      fontSize: 16,
    },
  },
});

export default StyledBox;
